/**
 * widgets/registry.certmgr.tsx — Certifikáty / CA (2.1).
 */
import { Download, FileText, Globe, Key, Server, Shield } from 'lucide-react';
import type { WidgetSpec } from './types';
import {
  CertificatesPanel,
  CertStorePanel,
  DnsProvidersWidgetPanel,
  DockerCaPanel,
  LePanel,
  OverviewPanel,
  TrustAnchorsPanel,
} from '../pages/modules/certmgr/panels';

export const CERTMGR_WIDGETS: WidgetSpec[] = [
  {
    id: 'certmgr.overview',
    title: 'Certificates overview',
    module: 'certmgr',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Shield,
    since: '2.1.0',
    component: OverviewPanel,
  },
  {
    id: 'certmgr.certificates',
    title: 'Mesh certificates',
    module: 'certmgr',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: FileText,
    since: '2.1.0',
    component: CertificatesPanel,
  },
  {
    id: 'certmgr.store',
    title: 'Cert store',
    module: 'certmgr',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: FileText,
    since: '2.1.0',
    component: CertStorePanel,
  },
  {
    id: 'certmgr.trust',
    title: 'Trust anchors',
    module: 'certmgr',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Download,
    since: '2.1.0',
    component: TrustAnchorsPanel,
  },
  {
    id: 'certmgr.le',
    title: "Let's Encrypt",
    module: 'certmgr',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.1.0',
    component: LePanel,
  },
  {
    id: 'certmgr.dns',
    title: 'DNS providers',
    module: 'certmgr',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Key,
    since: '2.1.0',
    component: DnsProvidersWidgetPanel,
  },
  {
    id: 'certmgr.docker',
    title: 'Root CA Docker',
    module: 'certmgr',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Server,
    since: '2.1.0',
    component: DockerCaPanel,
  },
];
